import { StyleSheet } from 'react-native';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import CARD_CONSTANTS from './constants';

export const styles = StyleSheet.create({
  cardContainerDesktop: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    minWidth: CARD_CONSTANTS.DEFAULT_CARD_WIDTH_DESKTOP,
    maxWidth: CARD_CONSTANTS.DEFAULT_CARD_WIDTH_DESKTOP,
    minHeight: CARD_CONSTANTS.DEFAULT_CARD_HEIGHT_DESKTOP,
    maxHeight: CARD_CONSTANTS.DEFAULT_CARD_HEIGHT_DESKTOP,
  },
  cardContainerTablet: {
    paddingVertical: 6,
    minWidth: CARD_CONSTANTS.DEFAULT_CARD_WIDTH_TABLET,
    maxWidth: CARD_CONSTANTS.DEFAULT_CARD_WIDTH_TABLET,
    minHeight: CARD_CONSTANTS.DEFAULT_CARD_HEIGHT_TABLET,
    maxHeight: CARD_CONSTANTS.DEFAULT_CARD_HEIGHT_TABLET,
  },
  unavailableContent: {
    opacity: 0.4,
  },
  cardTitleContainer: {
    overflow: 'hidden',
  },
  cardTitle: {
    color: colors['color-text-light-primary'],
  },
  cardChipsContainer: {
    marginTop: 5,
  },
  checkbox: {
    margin: 6,
  },
})
